import { IconButton, Stack, SvgIcon, TableCell, TableRow, Tooltip, Typography } from "@mui/material";
import { FC, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { getStyles } from "./styles";
import dayjs from "dayjs";
import { tokens } from "../../../../../../../locales/tokens";
import { Link } from "react-router-dom";
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

interface IProps {
    quiz: any;
    handleStatus: (id: number, status: string) => void;
    handleDelete: (id: number, mode?: string) => void;
    handleUpload: (id: number, name: string) => void;
};

export const QuizTableItem: FC<IProps> = ({ handleDelete, handleStatus, handleUpload, quiz }) => {
    const { t } = useTranslation();
    const styles = useMemo(() => getStyles(), []);
    const formattedDate = dayjs(quiz.updatedAt).subtract(3, 'hours').format('DD.MM.YYYY');
    const changeStatus = useCallback(() => handleStatus(quiz.id, quiz.status), [quiz.id, quiz.status]);
    const deleteQuiz = useCallback(() => {
        if (quiz.deleted_at) {
            handleDelete(quiz.id, 'hard');
        } else {
            handleDelete(quiz.id);
        }
    }, [quiz.id]);
    const uploadReport = useCallback(() => handleUpload(quiz.id, quiz.name), [quiz.id, quiz.name]);

    return (
        <TableRow hover key={quiz.id}>
            <TableCell align="left" width='50%' sx={styles.cell}>
                <Typography variant="body2">{quiz.name}</Typography>
            </TableCell>
            <TableCell align="center" width='25%' sx={styles.cell}>
                <Typography variant="body2">
                    {formattedDate}
                </Typography>
            </TableCell>
            <TableCell align="right" width='25%' sx={styles.cell}>
                <Stack direction='row' alignItems='center' spacing={1} justifyContent='flex-end'>
                    <IconButton size="small" onClick={uploadReport}>
                        <Tooltip title={t(tokens.documents.uploadReport)}>
                            <SvgIcon style={styles.svgIcon}><SimCardDownloadOutlinedIcon /></SvgIcon>
                        </Tooltip>
                    </IconButton>
                    {!quiz.deleted_at &&
                        <IconButton size="small" onClick={changeStatus}>
                            {quiz.status === 'Hidden' ?
                                <Tooltip title={t(tokens.documents.notPublish)}>
                                    <SvgIcon style={styles.svgIcon}><VisibilityOffOutlinedIcon /></SvgIcon>
                                </Tooltip>
                                :
                                <Tooltip title={t(tokens.documents.publish)} >
                                    <SvgIcon style={styles.svgIcon}><VisibilityOutlinedIcon /></SvgIcon>
                                </Tooltip>
                            }
                        </IconButton>}
                    <IconButton size="small" component={Link} to={`/content-quiz-edit/${quiz.id}`}>
                        <Tooltip title={quiz.deleted_at ? t(tokens.common.watch) : t(tokens.common.edit)}>
                            <SvgIcon style={styles.svgIcon}><EditOutlinedIcon /></SvgIcon>
                        </Tooltip>
                    </IconButton>
                    {!quiz.deleted_at ?
                        <IconButton size="small" onClick={deleteQuiz}>
                            <Tooltip title={t(tokens.common.delete)}>
                                <SvgIcon style={styles.svgIcon}><DeleteForeverIcon /></SvgIcon>
                            </Tooltip>
                        </IconButton>
                        :
                        <IconButton size="small" onClick={deleteQuiz}>
                            <Tooltip title={t(tokens.common.deleteHard)}>
                                <SvgIcon style={styles.svgIcon}><DeleteForeverIcon /></SvgIcon>
                            </Tooltip>
                        </IconButton>}
                </Stack>
            </TableCell>
        </TableRow>
    )
};